// entities/wheel.entity.js
// wheel.entity.js

/**
 * 游戏状态枚举
 */
export const GameStatus = Object.freeze({
  CREATED: 1,
  STARTED: 2,
  ENDED: 3,
  // 保持与 TS enum 一致的双向映射
  1: 'CREATED',
  2: 'STARTED',
  3: 'ENDED'
});

/**
 * 下注状态枚举
 */
export const BetStatus = Object.freeze({
  IN_GAME: 1,
  WON: 2,
  LOST: 3,
  1: 'IN_GAME',
  2: 'WON',
  3: 'LOST'
});

/**
 * 倍率枚举
 */
export const Multiplier = Object.freeze({
  X2: 1,
  X3: 2,
  X4: 3,
  X35: 4,
  1: 'X2',
  2: 'X3',
  3: 'X4',
  4: 'X35'
});

/**
 * 轮盘指针配置序列
 */
export const WHEEL_SPINNER =   [ 
        Multiplier.X35, Multiplier.X4, Multiplier.X2,  Multiplier.X3,  Multiplier.X2,  Multiplier.X3,  Multiplier.X4,  Multiplier.X3,  Multiplier.X2,  Multiplier.X4,
        Multiplier.X2,  Multiplier.X4, Multiplier.X2,  Multiplier.X3,  Multiplier.X2,  Multiplier.X3,  Multiplier.X2,  Multiplier.X3,  Multiplier.X2,  Multiplier.X4,
        Multiplier.X2,  Multiplier.X4, Multiplier.X2,  Multiplier.X3,  Multiplier.X2,  Multiplier.X3,  Multiplier.X2,  Multiplier.X3,  Multiplier.X2,  Multiplier.X3,
        Multiplier.X4,  Multiplier.X3, Multiplier.X2,  Multiplier.X4,  Multiplier.X2,  Multiplier.X4,  Multiplier.X2,  Multiplier.X3,  Multiplier.X2,  Multiplier.X3,
        Multiplier.X2,  Multiplier.X3, Multiplier.X2,  Multiplier.X4,  Multiplier.X2,  Multiplier.X4,  Multiplier.X2,  Multiplier.X3,  Multiplier.X2,  Multiplier.X3,
        Multiplier.X2,  Multiplier.X3, Multiplier.X2,  Multiplier.X4
];

/**
 * 倍率文本映射
 */
export const WHEEL_MULTIPLIERS = {
  [Multiplier.X2]: '2x',
  [Multiplier.X3]: '3x',
  [Multiplier.X4]: '4x',
  [Multiplier.X35]: '35x'
};

/**
 * 倍率颜色映射
 */
export const WHEEL_MULTIPLIERS_COLORS = {
  [Multiplier.X2]: 'blue',
  [Multiplier.X3]: 'green',
  [Multiplier.X4]: 'purple',
  [Multiplier.X35]: 'gold'
};

/**
 * Vue 2 组件中引用的 Mixin (可选，方便在组件 template 中直接使用枚举和常量)
 */
export const WheelEntityMixin = {
  data() {
    return {
      GameStatus,
      BetStatus,
      Multiplier,
      WHEEL_SPINNER,
      WHEEL_MULTIPLIERS,
      WHEEL_MULTIPLIERS_COLORS
    };
  }
};

export class Game {
  constructor(data = {}) {
    this.id = data.id || null;
    this.status = data.status || GameStatus.CREATED;
    this.winColor = data.winColor || null;
    this.winNumber = data.winNumber || null;
    this.startAt = data.startAt || null;
    this.endAt = data.endAt || null;
    this.prevAngle = data.prevAngle || 0;
    this.wheelTransform = data.wheelTransform || 0;
    this.usersCount = data.usersCount || 0;
    this.totalBankUsd = data.totalBankUsd || 0;
    this.fairGame = data.fairGame || null;
  }
}

export class Bet {
  constructor(data = {}) {
    this.id = data.id || null;
    this.user = data.user || { id: null, nickname: '', avatar: '', nicknameColor: '' };
    this.color = data.color || Multiplier.X2;
    this.itemsTotal = data.itemsTotal || 0;
    this.itemsCount = data.itemsCount || 0;
    this.items = data.items || [];
    this.winItem = data.winItem || null;
    this.winItemPrice = data.winItemPrice || 0;
    this.isOwn = data.isOwn || false;
    this.isAnimated = data.isAnimated || false;
    this.status = data.status || BetStatus.PENDING;
  }
}

export class WheelColor {
  constructor(data = {}) {
    this.bets = data.bets || [];
    this.totalBankUsd = data.totalBankUsd || 0;
    this.usersCount = data.usersCount || 0;
  }
}